// extracted by mini-css-extract-plugin
export default {"pageComponents":"pageComponents_pageComponents__kE1hd"};